import type { SortFunction } from '@/models/sorting.model';

export const createStringSort = <T>(getValue: (item: T) => string): SortFunction<T> => {
  return (a: T, b: T) => getValue(a).localeCompare(getValue(b));
};
